import * as angular from 'angular';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-cookies';
import 'angular-material';
import 'angular-translate';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-translate-interpolation-messageformat';
import 'angular-material-data-table';
import 'angular-simple-logger';
import 'lodash';
import 'highcharts-ng'
import 'angular-google-maps';
import 'ng-file-upload';
import 'angular-ui-router';
import 'angular-material/angular-material.css';
import 'angular-material-data-table/dist/md-data-table.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './common/variables.css';
import './fonts.css';
import imomoApi from './api/api.module';
import imomoAuth from './auth/auth.module';
import imomoDischarge from './discharge/discharge.module';
import imomoError from './error/error.module';
import imomoHydromet from './hydromet/hydromet.module';
import imomoLogin from './login/login.module';
import imomoNews from './news/news.module';
import imomoOperational from './operational/operational.module';
import imomoForecasting from './hydromet/forecasting/forecasting.module';
import imomoSnackbar from './snackbar/snackbar.module';
import imomoStation from './station/station.module';
import imomoMeteostation from './meteostation/meteostation.module';
import imomoUtils from './utils/utils.module';
import {translateSources, adjustMomentLocale, } from './locales';
import ITranslateProvider = angular.translate.ITranslateProvider;
import IDateLocaleProvider = angular.material.IDateLocaleProvider;
import moment = require("moment");
import IOrganizationApi from './api/organization-api.service';
import {ITranslateService} from 'angular-translate';

const angulartics = require<string>('angulartics');
const angularticsGA = require<string>('angulartics-google-analytics');

angular.module('imomo', [
  'ngSanitize',
  'ngCookies',
  'ngMessages',
  'ngMaterial',
  'pascalprecht.translate',
  'md.data.table',
  'uiGmapgoogle-maps',
  'nemLogging',
  'ngFileUpload',
  'ui.router',
  'highcharts-ng',
  angulartics,
  angularticsGA,
  imomoApi,
  imomoAuth,
  imomoDischarge,
  imomoError,
  imomoHydromet,
  imomoLogin,
  imomoNews,
  imomoOperational,
  imomoForecasting,
  imomoSnackbar,
  imomoStation,
  imomoMeteostation,
  imomoUtils
]).config(['$translateProvider', '$mdDateLocaleProvider', 'uiGmapGoogleMapApiProvider',
    function config($translateProvider: ITranslateProvider,
                    $mdDateLocaleProvider: IDateLocaleProvider,
                    uiGmapGoogleMapApiProvider: any) {

        translateSources($translateProvider);

        $mdDateLocaleProvider.formatDate = function(date) {
            return moment(date).format('MMMM DD, YYYY');
        };

        uiGmapGoogleMapApiProvider.configure({key: 'AIzaSyDd0kS2obTjliCgtb3bMbmlIaYWMlEg2Ps'})

    }
]).run(runFunction);


angular.element(document).ready(() => {
  angular.bootstrap(document, ['imomo'], {strictDi: true});
});

function runFunction(
    organizationApi: IOrganizationApi,
    $window: ng.IWindowService,
    $rootScope: ng.IRootScopeService,
    $translate: ITranslateService,
    $log: ng.ILogService
  ) {
  adjustMomentTimezone(organizationApi, $window);
  adjustMomentLocale($rootScope, $translate, $log);
}

function adjustMomentTimezone(
    organizationApi: IOrganizationApi,
    $window: ng.IWindowService,
  ) {
  const timezone = $window.localStorage.getItem('orgTimezone');

  if (timezone) {
    moment.tz.setDefault(timezone);  
  } else {
    organizationApi.getOrganization(parseInt($window.localStorage.getItem('currentOrgId'), 10))
      .then((org) => {
        moment.tz.setDefault(org.timezone);
        $window.localStorage.setItem('orgTimezone', org.timezone)
      })
  }
}

runFunction.$inject = [ 'organizationApi', '$window', '$rootScope', '$translate', '$log']





/** WEBPACK FOOTER **
 ** ./app/app.ts
 **/